export default {
    jiraEmail: '',
    jiraToken: '',
    hasJiraToken: false,
    migrationToken: '',
    hasMigrationToken: false,
    enableMigratedProfiles: false,
    loaderVisible: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/migration/state.js